// 清除博客数据的工具函数
export const clearBlogData = () => {
  try {
    localStorage.removeItem('blog_posts');
    localStorage.removeItem('blog_stats');
    console.log('博客数据已清除');
    return true;
  } catch (error) {
    console.error('清除博客数据失败:', error);
    return false;
  }
};

// 在浏览器控制台中可以调用这个函数来清除数据
// 使用方法：在浏览器控制台输入 window.clearBlogData()
if (typeof window !== 'undefined') {
  (window as any).clearBlogData = clearBlogData;
}